export const SAVE_EMAIL_VERIFY_DATA = 'SAVE_EMAIL_VERIFY_DATA';
export const SET_OTP_STATE = 'SET_OTP_STATE';
export const RESET_OTP_STATE = 'RESET_OTP_STATE';
export const SET_EMAIL_VERIFY_WALL_DATA = 'SET_EMAIL_VERIFY_WALL_DATA';
export const IS_VERIFY_WALL_FETCHING = 'IS_VERIFY_WALL_FETCHING';
export const RESET_VERIFY_WALL_FETCHING = 'RESET_VERIFY_WALL_FETCHING';
export const SAVE_CHANGE_EMAIL_VERIFY_DATA = 'SAVE_CHANGE_EMAIL_VERIFY_DATA';
export const SET_CHANGE_EMAIL_FETCHING = 'SET_CHANGE_EMAIL_FETCHING';
export const RESET_CHANGE_EMAIL_FETCHING = 'RESET_CHANGE_EMAIL_FETCHING';
export const SET_SHOW_SELFIE_VERIFICATION_WALL = 'SET_SHOW_SELFIE_VERIFICATION_WALL';
export const IS_SV_WALL_BY_GET_SELFIE_VERIFIED = 'IS_SV_WALL_BY_GET_SELFIE_VERIFIED';
export const SET_FACELIVENESS_VERIFY_LOADER = 'SET_FACELIVENESS_VERIFY_LOADER';
export const START_SELFIE_VERIFICATION = 'START_SELFIE_VERIFICATION';
export const SET_FACELIVENESS_STATUS = 'SET_FACELIVENESS_STATUS';
export const UPDATE_PROFILE_LIVENESS_STATUS = 'UPDATE_PROFILE_LIVENESS_STATUS';
export const SKIP_SELFIE_VERIFICATION_WALL_CHECK = 'SKIP_SELFIE_VERIFICATION_WALL_CHECK';
